"use client"

import { useEffect } from "react"

interface StructuredDataProps {
  data: any
}

export function StructuredData({ data }: StructuredDataProps) {
  useEffect(() => {
    // Remove any existing script with the same ID
    const existingScript = document.getElementById("structured-data")
    if (existingScript) {
      existingScript.remove()
    }

    // Create a new script element
    const script = document.createElement("script")
    script.id = "structured-data"
    script.type = "application/ld+json"
    script.textContent = JSON.stringify(data)

    // Add the script to the document
    document.head.appendChild(script)

    // Clean up on unmount
    return () => {
      const scriptToRemove = document.getElementById("structured-data")
      if (scriptToRemove) {
        scriptToRemove.remove()
      }
    }
  }, [data]) // Re-run when data changes

  // Return null since we're manually managing the script
  return null
}
